export default __webpack_public_path__ + "static/media/empty.b6ddfbdc.png";